import '/Users/ludoviczamord/projects/up-group/Up.Public.ReactControls/node_modules/@storybook/addon-interactions/dist/manager.mjs';